import React, { useContext } from 'react';
import { FilterBarContext, FilterFieldName } from '../FilterBarContext';
import { LocationSelect } from '@/modules/locations/components/LocationSelect';
import { LocationModel } from '@/modules/locations/types/LocationModel';

interface ToLocationFilterProps {
  label: string;
}

const ToLocationFilter: React.FC<ToLocationFilterProps> = ({ label }) => {
  const { setFilterValue, filterValues } = useContext(FilterBarContext);

  function onLocationSelected(location: LocationModel | null) {
    if (location) {
      setFilterValue(FilterFieldName.toLocationId, location.dto.id, location.dto.name);
    } else {
      setFilterValue(FilterFieldName.toLocationId, undefined);
    }
  }

  return (
    <LocationSelect
      label={label}
      selectedLocationId={filterValues.toLocationId ? Number.parseInt(filterValues.toLocationId.toString()) : undefined}
      onSelected={onLocationSelected}
    />
  );
};

export default ToLocationFilter;
